import { render, staticRenderFns } from "./ViewTable.vue?vue&type=template&id=e97cb4c2&scoped=true&"
import script from "./ViewTable.vue?vue&type=script&lang=js&"
export * from "./ViewTable.vue?vue&type=script&lang=js&"
import style0 from "./ViewTable.vue?vue&type=style&index=0&id=e97cb4c2&prod&lang=scss&"
import style1 from "./ViewTable.vue?vue&type=style&index=1&id=e97cb4c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97cb4c2",
  null
  
)

export default component.exports